export const renderBrowserTestingV1WorkflowAuthoring =
  (): string => `## Creating Tests from Browser Exploration

After exploring an app via \`canary session\`, you can persist what you discovered as a reusable test workflow.

### Explore → Author → Create flow

1. **Explore**: Use \`canary session\` to navigate, snapshot, and interact with the app
2. **Author**: Construct workflow JSON with nodes and playbook steps based on what was observed
3. **Create**: Pipe JSON to \`canary workflow create\`
4. **Verify**: Check with \`canary workflow get <id>\`

### Node authoring guidance

- Group related actions into single action nodes (one node per logical step, not per click)
- Node types: \`login\` (authentication), \`navigate\` (go to URL), \`action\` (interact with elements), \`assertion\` (verify standalone page state), \`end\` (terminal node)
- Every action node **must** have a \`customActionTitle\` — a short (3-8 word) human-readable title describing the step
- **Prefer inline assertions** on action nodes over separate assertion nodes. Add \`inlineAssertions\` to verify outcomes right after the action completes. Use separate \`assertion\` nodes only for standalone page-level verifications (e.g., initial page state before any action)
- Inline assertion format: \`{ "condition": "...", "severity": "fatal" | "fail" | "warn" }\` (fatal = halt the test now, fail = mark run failed but continue, warn = record only). **Do not author an \`id\` field** — the server stamps a UUID on persist. Hand-rolled UUIDs (especially placeholders like \`a1b2c3d4-...\`) are rejected and replaced.

`;
